import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdministrationComponent } from './administration.component';
import { AdministrationRoutingModule } from './administration-routing.module';
import { SpecialDaysModule } from './special-days/special-days.module';
import { TeacherModule } from './teacher/teacher.module';
import { GroupsPermissionsModule } from './groups-permissions/groups-permissions.module';
import {
  BasicProcessConfigurationModule
} from './basic-process-configuration/basic-process-configuration.module';
import { DocumentsModule } from './documents/documents.module';
import { ManagementSystemModule } from './management-system/management-system.module';

@NgModule({
  imports: [
    CommonModule,
    BasicProcessConfigurationModule,
    TeacherModule,
    AdministrationRoutingModule,
    SpecialDaysModule,
    GroupsPermissionsModule,
    DocumentsModule,
    ManagementSystemModule

  ],
  declarations: [AdministrationComponent]
})
export class AdministrationModule { }



// WEBPACK FOOTER //
// ./src/app/administration/administration.module.ts